export default "__VITE_ASSET__DZOUEUvX__"